import { File } from './File.js';
export class Resolution {
    /// Path to the server
    file;
    width;
    height;
    constructor(data) {
        this.file = data.file;
        this.width = data.width;
        this.height = data.height;
    }
    static decode(data) {
        return new Resolution({
            file: data.field('file').decode(File),
            width: data.field('width').integer,
            height: data.field('height').integer,
        });
    }
    encode(context) {
        return {
            file: this.file.encode(context),
            width: this.width,
            height: this.height,
        };
    }
}
//# sourceMappingURL=Resolution.js.map